import type { ExtractPropTypes } from 'vue'

export const tipProps = {
	flex: Boolean,
	// 图标
	icon: { type: [String, Boolean], default: 'info' },
	// 显示内容
	content: { type: String, default: '' },
	// 色彩
	color: { type: String, default: 'default' },
	// 操作按钮显示方式 always：一直显示 hover：鼠标悬移时显示
	opDisplay: { type: String, default: '' },
	// 类型 none：无填充 fill：填充 line：边框 plain：朴素 toast：土司片
	mode: { type: String, default: 'default' },
	// 位置 top 从顶部弹出
	position: { type: String, default: '' },
	// 自动隐藏延迟时间
	during: {
		type: [Number, String],
		default() {
			// return this.$TouchUI.tip && this.$TouchUI.tip.during || 3000
			return 3000
		}
	},
	// 支持关闭
	closable: Boolean,
	// 支持 “不再显示”
	removable: Boolean,
	// 自定义类名
	className: {
		type: String,
		default: ''
	},
	close: { type: Function, default: () => true },
	open: { type: Function, default: () => true }
}

export type TipProps = ExtractPropTypes<typeof tipProps>

export const tipEmits = ['delete', 'close', 'remove']

export type TipEmits = typeof tipEmits
